module.exports = __webpack_public_path__ + "static/psi_warrior-977845708c37fdbb51dc6c884975930c.png";